import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css'; // CSS再利用

const Machiya = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    // ▼▼▼ ADDED ▼▼▼
    // Function to open the lightbox
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        // ▼▼▼ Wrapped with Fragment <> ▼▼▼
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>歴史ある町家で過ごす｜5つの魅力｜金沢之旅宿 あけぼの</title>
                <meta name="description" content="150年以上の歴史を誇る金澤町家「あけぼの」。書院造りの様式美や伝統的な建築の工夫が随所に残る空間です。歴史が息づく本物の町家で、特別な滞在をご体験ください。" />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="150年の歴史を誇る金澤町家｜金沢之旅宿 あけぼの" />
                <meta property="og:description" content="書院造りの様式美や伝統的な建築の工夫が随所に残る空間。歴史が息づく本物の町家で、特別な滞在をご体験ください。" />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/machiya4.jpg" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HEROセクション */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/machiya4.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>歴史ある町家で過ごす</h1>
                    </div>
                </section>

                {/* セクション①：町家とは何か */}
                <section className="akebono-garden-culture">
                    <h2>金澤町家について</h2>
                    <p>
                        あけぼの の建物は、金澤町家として150年以上の歴史を誇ります。金澤町家のこだわりは、壁・ふすま・柱など隅々に及びます。
                    </p>
                    <p>
                        滞在中は、170㎡の館内で建築美もお楽しみください。
                    </p>
                    <p>
                        江戸時代、城下町や港町などの町人居住地に建ち並んでいた建物で、商人や職人たちが住んでいた都市住宅を町家といいます。
                    </p>
                    <p>
                        明治維新後、西洋文明の影響で変容した伝統的建築様式、技法、材料によって建てられたものを、近代和風住宅といいます。
                    </p>
                    <p>
                        金澤町家は、昭和25年（1950年）以前に建てられ、町家、武士系住宅、近代和風住宅と呼ばれる歴史的建築物の総称です。
                    </p>
                    <p>
                        あけぼの は、金澤町屋のうち近代和風住宅にあたります。
                    </p>

                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/machiya1.jpg" alt="町家外観" onClick={() => openLightbox('/images/machiya1.jpg')} />
                        <img src="/images/machiya2.jpg" alt="玄関と格子戸" onClick={() => openLightbox('/images/machiya2.jpg')} />
                        <img src="/images/machiya3.jpg" alt="中庭の風景" onClick={() => openLightbox('/images/machiya3.jpg')} />
                        <img src="/images/machiya4.jpg" alt="室内の和室" onClick={() => openLightbox('/images/machiya4.jpg')} />
                    </div>
                </section>

                {/* セクション②：建物の構造と工夫 */}
                <section className="akebono-garden-feature">
                    <h2>書院造りと建築の工夫</h2>
                    <p>
                        書院造りとは、平安貴族の寝殿造りから発展し、武家の住まいに取り入れられた住宅様式です。室町時代の「東山文化」により格式ある客間として発展し、江戸時代には全国に広まりました。
                    </p>
                    <p>
                        畳敷きの床、床の間、障子や欄間といった意匠は、客人をもてなす「おもてなし」の精神を空間に宿します。
                    </p>
                    <p>
                        あけぼの では、こうした伝統を受け継ぎながら、床暖房や断熱ガラスなど現代の快適性も兼ね備えた空間を整えています。歴史と現代の調和がもたらす、特別なひとときをお楽しみください。
                    </p>
                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/howto-hero.jpg" alt="おもてなしの空間" onClick={() => openLightbox('/images/howto-hero.jpg')} />
                        <img src="/images/room3.jpg" alt="書院造りの部屋" onClick={() => openLightbox('/images/room3.jpg')} />
                        <img src="/images/feature-machiya.png" alt="欄間" onClick={() => openLightbox('/images/feature-machiya.png')} />
                        <img src="/images/entrance2.jpg" alt="玄関の意匠" onClick={() => openLightbox('/images/entrance2.jpg')} />
                    </div>
                </section>


                {/* Lightbox 拡大表示 */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        {/* ▼▼▼ CORRECTED LIGHTBOX ▼▼▼ */}
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="拡大表示" className="lightbox-content" />
                    </div>
                )}

            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲
    );
};

export default Machiya;